import axios from "@/plugins/axios";

let url = "/api/console/nshop/viewer-statistics";

/**
 * @typedef {object} $NshopViewerStatisticItem
 *
 * @property {string?} _id 추천인(뷰어) _id. 추천인이 지정되지 않은 주문은 null 로 내려온다
 *
 * @property {object} viewer
 * @property {string} viewer.refid 추천인코드
 * @property {string} viewer.username
 * @property {string} viewer.name
 *
 * @property {object} order
 * @property {number} order.count
 * @property {number} order.sales
 *
 * @property {object} message
 * @property {number} message.count 알림톡 + 대체문자
 *
 * @property {object} message.kakao
 * @property {number} message.kakao.count
 *
 * @property {object} message.plain
 * @property {number} message.plain.count
 */

export const viewerStatistics = {
    /**
     * @param {import("axios").AxiosRequestConfig} data
     * @returns {Promise<{ summary: { totalCount: number, order: $NshopViewerStatisticItem['order'], message: $NshopViewerStatisticItem['message'] }, statistics: $NshopViewerStatisticItem[]}>}
     */
    gets(data) {
        return axios.get(url, data).then((result) => result.data);
    },
};

export default viewerStatistics;
